module.exports = __webpack_public_path__ + "static/media/ecopies-orders.dc6b7d07.png";